/**
 * usage shirtOrderStatus[<status>] Can use Globally
 * Example - shirtOrderStatus.NEW_ORDER, shirtOrderStatus.COLLECTOR_PRINTED
 * this Object can call from anywhere in vue pages
*/
export default {
    NEW_ORDER: 0,
    COLLECTOR_PRINTED: 100,
    PATTERN_PRINTED: 101,
    DOCUMENT_PRINTED: 50,
    CUTTING_PREPARATION: 58,
    C_AND_C_CUTTING: 59,
    CUTTING: 102,
    WAITING_FOR_EMB: 51,
    FUSING_AND_EMB: 53,
    STITCHING_1: 103,
    STITCHING_2: 60,
    BUTTONS: 54,
    WAITING_FOR_BUTTON: 56,
    WAITING_FOR_BUTTON_2: 55,
    BUTTON_HOLE: 104,
    QC_1: 105,
    PACKAGING: 106,
    SHELF: 107,
    QC_2: 57,
    SENT_TO_GERMANY: 108,
}
